import {
    DisplayFunction,
    DisplayOrder,
    ExportFunction,
    Number,
    SortDefault,
    String,
    TableDisplayedDefault
} from '@ui-kit/webkit/components/crud-item/crud-item-decorator';
import { formatAtokuCurrency } from './atoku-crud.utils';

export class CrudAtokuInventoryItem {
    id: string = '';

    @DisplayOrder(1)
    @TableDisplayedDefault
    @SortDefault('asc')
    @String('Name')
    name: string = '';

    @DisplayOrder(2)
    @TableDisplayedDefault
    @Number('Total Amount')
    totalAmount: number = 0;

    @DisplayOrder(3)
    @TableDisplayedDefault
    @Number('Total Booked (Past 30 Days)')
    bookedLast30Days: number = 0;

    @DisplayOrder(4)
    @TableDisplayedDefault
    @DisplayFunction(formatAtokuCurrency)
    @ExportFunction(formatAtokuCurrency)
    @Number('Price')
    price: number = 0;

    constructor(obj: Partial<CrudAtokuInventoryItem> = {}) {
        Object.assign(this, obj);
    }
}
